<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>a = b | ∠A=90° | AC ⊥ BD$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(175, 60)">
            <rect x="0" y="0" width="150" height="150" fill="rgba(0, 210, 255, 0.15)" stroke="#00d2ff" stroke-width="3" />
            
            <!-- Right angles -->
            <rect x="0" y="0" width="15" height="15" fill="none" stroke="#ffd700" stroke-width="1" />
            
            <!-- Diagonals -->
            <line x1="0" y1="0" x2="150" y2="150" stroke="rgba(255,255,255,0.2)" stroke-dasharray="4" />
            <line x1="150" y1="0" x2="0" y2="150" stroke="rgba(255,255,255,0.2)" stroke-dasharray="4" />

            <!-- Center square marker (90 deg diagonals) -->
            <rect x="67" y="67" width="16" height="16" fill="none" stroke="#ffd700" stroke-width="1" transform="rotate(45, 75, 75)" />
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>正方形性质：</strong>既是矩形又是菱形的特殊四边形。四条边都相等，四个角都是直角。对角线相等、互相垂直平分，且平分每组对角。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SquareViz',
  props: { knowledgePoint: { type: String, default: '' } }
}
</script>

<style scoped lang="scss">
.quad-viz-pure { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>